// extracted by mini-css-extract-plugin
export default {"module":"closeButton_module__bM0wX"};